import { ActionTypesChat } from "../constants/action-types";


export const initChat =()=>{
    return {
        type: ActionTypesChat.INIT_CHAT,
    }
}


export const newMessageRecieved =(message)=>{
    return {
        type: ActionTypesChat.NEW_MESSAGE_RECEIVED,
        payload:{
            message
        }
    }
}

export const addParticipant =(participant)=>{
    return {
        type: ActionTypesChat.ADD_PARTICIPANT,
        payload:{
            participant
        }
    }
}

export const removeParticipant =(participant)=>{
    return {
        type: ActionTypesChat.REMOVE_PARTICIPANT,
        payload:{
            participant
        }
    }
}

export const engagementCreated =(participant)=>{
    return {
        type: ActionTypesChat.ENGAGEMENT_CREATED,
        payload:{
            participant
        }
    }
}

export const setSocketConnectivity = (status)=>{
    return {
        type: ActionTypesChat.SET_SOCKET_CONNECTIVITY,
        payload:{
            isSocketConnected:status
        }
    }
}

export const setSocketInstance = (socket)=>{
    return {
        type: ActionTypesChat.SET_SOCKET_INSTANCE,
        payload:{
            socket
        }
    }
}



